import React from 'react';
import Icon from '../../Components/Icons/Icon';
import { recipientStatuses } from '../../Data/Broadcasts';
import { classNames } from '../../Services/helpers';

const colours = {
    'invalid': 'fill-muted',
    'pending': 'fill-brand',
    'success': 'fill-green-600',
    'error': 'fill-red-600',
}

const RecipientStatus = ({recipient}) => {
    const status = recipientStatuses[recipient.status];

    return <div className="text-muted text-sm flex flex-col items-center justify-between min-w-24">
        <Icon icon={status.icon} className={classNames('mb-1', colours[status.type])} size="2x" />
        {recipient.status}
    </div>
}

export default RecipientStatus;